import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import ButtonComponent, {
  ButtonProps,
} from "../../../../../../common/components/button/button.component";

type OrderOptimizerRailyDetailsToolButtonProps = Pick<
  ButtonProps,
  "onClick" | "title" | "isDisabled" | "type" | "isLoading"
> & {
  icon: IconProp;
  isButtonClicked: boolean;
};

const OrderOptimizerRailyDetailsToolButtonComponent: FC<
  OrderOptimizerRailyDetailsToolButtonProps
> = (props) => {
  return (
    <ButtonComponent
      onClick={props.onClick}
      title={props.title}
      classNames={{
        root: classNames(
          "order_optimizer_raily_details_tools_button",
          props.isDisabled && "disabled"
        ),
      }}
      type={props.isButtonClicked ? "success" : "primary"}
      isDisabled={props.isDisabled}
      isLoading={props.isLoading}
    >
      <FontAwesomeIcon
        icon={props.icon}
        className="order_optimizer_raily_details_tools_button__icon"
      />
    </ButtonComponent>
  );
};

export default OrderOptimizerRailyDetailsToolButtonComponent;
